module.exports = __webpack_public_path__ + "static/img/5091_phase_function_Paper_PointsHejduk_Prediction.347520a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5091_phase_function_Paper_PointsHejduk_Prediction.png
// module id = caxP
// module chunks = 0